module.exports = __webpack_public_path__ + "img/goodsB5.2e5c658e.png";